import { makeStyles, shorthands } from '@fluentui/react-components';

export const usePerformanceFilterBarEditingStyle = makeStyles({
  filterBarEditingContainer: {
    position: 'relative',
    minHeight: '56px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#f3f2f1',

    '& .filter-list-editing': {
      display: 'flex',
      ...shorthands.flex(1),
      flexWrap: 'wrap',
      alignItems: 'flex-start',
      paddingLeft: '12px',

      '& .filter-list-divider': {
        paddingRight: '12px',
      },
    },

    '& .filter-bar-button-group': {
      marginLeft: 'auto',
      display: 'flex',
    },

    '& button.add-filter-button .iconba-Add': {
      color: '#373737',
    },
    '& button.filter-bar-button': {
      ...shorthands.border('none'),
      backgroundColor: 'transparent',
      ...shorthands.padding('0px', '7px'),
      height: '56px',
      '& .iconba': {
        color: '#373737',
      },
      '&:hover': {
        backgroundColor: '#f3f2f1',
      },
      '&:focus': {
        backgroundColor: '#e1dfdd',
        '&:hover': {
          backgroundColor: '#d0d0d0',
        },
      },
    },
    '& .filter-bar-divider': {
      ...shorthands.borderLeft('1px', 'solid', '#eaeaea'),
      ...shorthands.margin('8px', '0px'),
    },
    '& button.filter-bar-cancel-button': {
      ...shorthands.padding('0px', '18px'),
      minWidth: 'auto',
      '& .iconba:before': {
        color: '#373737',
      },
    },
  },
});

export const usePerformanceFilterBarReadonlyStyle = makeStyles({
  filterBarReadonlyContainer: {
    display: 'flex',
    alignItems: 'center',

    '& .btn.btn-link': {
      marginLeft: '5px',
      color: '#17717a',
      ...shorthands.textDecoration('underline'),
    },

    '& .filter-list': {
      height: '56px',
      paddingLeft: '12px',
      display: 'block',
      alignItems: 'center',
      textOverflow: 'ellipsis',
      color: '#17717a',
      ...shorthands.overflow('hidden'),
      whiteSpace: 'nowrap',

      fontFamily: 'Segoe UI',
      fontSize: '14px',
      lineHeight: '19px',
      paddingTop: '14px',

      '& .asset-library-search': {
        top: '0px',
      },
    },
    '& .filter-list:focus-within': {
      textOverflow: 'inherit', // collpase text would invisiable issues when use tab to change focus, reference here: https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_workitems/edit/3702640/
    },
  },
  addFilterButton: {
    ...shorthands.flex(0, 0, 'auto'),
    ...shorthands.border('none'),
    height: '56px',
    fontSize: '14px',
    marginLeft: '4px',
    paddingLeft: '8px',
    paddingRight: '8px',
    backgroundColor: '#ffffff',
    fontWeight: '600',
  },
});

export const useViewAllFiltersButtonStyle = makeStyles({
  viewAllButton: {
    ...shorthands.border('none'),
    color: 'rgb(23, 113, 122) !important',
    fontWeight: '400',
    width: 'auto',
    minWidth: '0px !important',
    ...shorthands.padding('0px !important', '8px !important'),
    backgroundColor: 'transparent !important',
    lineHeight: '56px !important',
    '&:hover': {
      ...shorthands.textDecoration('underline'),
    },
  },
  viewContentTitle: {
    paddingLeft: '8px',
    fontWeight: '600',
    fontSize: '20px',
  },
  viewAllFilterItem: {
    display: 'block',
    ...shorthands.border('none'),
    color: 'rgb(23, 113, 122) !important',
    fontWeight: '400',
    width: 'auto',
    minWidth: '0px !important',
    ...shorthands.padding('0px !important', '8px !important'),
    height: 'auto',
    backgroundColor: 'transparent !important',
    '&:hover': {
      ...shorthands.textDecoration('underline'),
    },
  },
});
